import React from 'react';
import './AppModalContent.scss';

const AppModalContent = (props) => 
    <div className="app-modal-mobile-content">
        { props.children }
    </div>

export default AppModalContent;